export default {
  SET_IS_LOGGED_IN(state, isLoggedIn) {
    state.isLoggedIn = isLoggedIn
  },
  SET_LOGIN(state, login) {
    state.login = login
  },
  SET_API_KEY(state, apiKey) {
    state.apiKey = apiKey
  },
  SET_CONFIG(state, config) {
    state.config = config
  },
  SET_TENANT(state, tenant) {
    state.tenant = tenant
  },
}
